import { createDefaultTyrann } from '@apis/common';
import { contact, contactQuery, patchContact, postContact } from '@models/Contact';
import * as t from 'io-ts';

export const contactApis = createDefaultTyrann({
  '/contact/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: contact,
        404: t.type({}),
      },
    },
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: patchContact,
      response: {
        200: contact,
      },
    },
    delete: {
      path: t.type({
        id: t.number,
      }),
      response: {
        204: t.unknown,
      },
    },
  },
  '/contact/': {
    get: {
      query: contactQuery,
      response: {
        200: t.array(contact),
      },
    },
    post: {
      body: postContact,
      response: {
        201: contact,
      },
    },
  },
});
